/* Page Lissage : simulateur de prix (texture + coupe -> prix, acompte 30 %, lien de reservation)
   et videos clientes lancees au toucher. */
(function () {
  var PRODUCT = "https://www.grenadinehair.com/products/lissage-cheveux-salon-coiffure-lyon";
  var V = {
    fins:   { name: "Lion Queen",     label: "Cheveux fins",                 sans: [55109708579151, 260], avec: [55109746884943, 280] },
    blonds: { name: "Oh My Blond",    label: "Cheveux blonds, blancs ou méchés", sans: [55109708611919, 260], avec: [55109746917711, 280] },
    moyens: { name: "Classic Bae",    label: "Cheveux moyens",               sans: [55109708644687, 260], avec: [55109746950479, 280] },
    epais:  { name: "Bold Honey",     label: "Cheveux épais",                sans: [55109708677455, 320], avec: [55109746983247, 340] },
    afro:   { name: "Bold Honey +",   label: "Cheveux afro & crépus",        sans: [55109747016015, 390], avec: [55109747048783, 410] }
  };
  function euros(n) { return (Math.round(n * 100) / 100).toFixed(n % 1 ? 2 : 0).replace(".", ",") + " €"; }

  function initSimu(root) {
    var tex = "moyens", cut = "sans";
    var price = root.querySelector("[data-lbs-price]"), formula = root.querySelector("[data-lbs-formula]"),
        acompte = root.querySelector("[data-lbs-acompte]"), solde = root.querySelector("[data-lbs-solde]"),
        cta = root.querySelector("[data-lbs-cta]");
    function paint() {
      var f = V[tex], v = f[cut];
      formula.textContent = f.name + " · " + f.label + (cut === "avec" ? " · avec coupe" : " · sans coupe");
      price.textContent = euros(v[1]);
      acompte.textContent = euros(v[1] * 0.3);
      solde.textContent = euros(v[1] * 0.7);
      cta.href = PRODUCT + "?variant=" + v[0];
      root.querySelectorAll("[data-lbs-tex]").forEach(function (b) { b.classList.toggle("is-on", b.getAttribute("data-lbs-tex") === tex); });
      root.querySelectorAll("[data-lbs-cut]").forEach(function (b) { b.classList.toggle("is-on", b.getAttribute("data-lbs-cut") === cut); });
    }
    root.addEventListener("click", function (e) {
      var t = e.target.closest("[data-lbs-tex]"), c = e.target.closest("[data-lbs-cut]");
      if (t) { tex = t.getAttribute("data-lbs-tex"); paint(); }
      if (c) { cut = c.getAttribute("data-lbs-cut"); paint(); }
    });
    paint();
  }

  function initVideos() {
    var all = document.querySelectorAll(".lbx-vid");
    all.forEach(function (box) {
      var v = box.querySelector("video");
      box.addEventListener("click", function () {
        if (v.paused) {
          all.forEach(function (o) { if (o !== box) { var ov = o.querySelector("video"); if (!ov.paused) ov.pause(); o.classList.remove("is-playing"); } });
          if (!v.getAttribute("src")) v.src = v.getAttribute("data-src");
          v.muted = false;
          var p = v.play(); if (p && p.catch) p.catch(function () { v.muted = true; v.play(); });
          box.classList.add("is-playing");
        } else { v.pause(); box.classList.remove("is-playing"); }
      });
    });
  }

  function init() {
    document.querySelectorAll("[data-lbs]").forEach(initSimu);
    initVideos();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
})();
